<template>
<div class="col s12 m9">
      <div>
        <h5>Robotics</h5>
        <hr>
      </div>
      <div class = "container video-container ">
        <!-- spinner -->
          <div class="loadings container" id="loading" v-if="LoadingMSG">
            <div class="preloader-wrapper big active">
              <div class="spinner-layer spinner-blue">
                <div class="circle-clipper left">
                  <div class="circle"></div>
                </div><div class="gap-patch">
                  <div class="circle"></div>
                </div><div class="circle-clipper right">
                  <div class="circle"></div>
                </div>
              </div>

              <div class="spinner-layer spinner-red">
                <div class="circle-clipper left">
                  <div class="circle"></div>
                </div><div class="gap-patch">
                  <div class="circle"></div>
                </div><div class="circle-clipper right">
                  <div class="circle"></div>
                </div>
              </div>

              <div class="spinner-layer spinner-yellow">
                <div class="circle-clipper left">
                  <div class="circle"></div>
                </div><div class="gap-patch">
                  <div class="circle"></div>
                </div><div class="circle-clipper right">
                  <div class="circle"></div>
                </div>
              </div>

              <div class="spinner-layer spinner-green">
                <div class="circle-clipper left">
                  <div class="circle"></div>
                </div><div class="gap-patch">
                  <div class="circle"></div>
                </div><div class="circle-clipper right">
                  <div class="circle"></div>
                </div>
              </div>
            </div>
          </div>
  <!-- end of spinner -->
       <div class="row">
          
        </div> 
        <div class="responsive-video col">
          <iframe src="https://www.youtube.com/embed/HBtmvAjGIvw" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div>
        <p><b>Video:</b> The video shows the demo flight of the quadcopter.</p>
      </div>
<hr>
      <div class="responsive-video">
          <iframe src="https://www.youtube.com/embed/LWshG38u6Z0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>  
      </div>
     
        <p><b>Video:</b> Aire Quality Monitoring Station.</p>
        <hr>
      </div> <!--Row-->
</template>

<script>
export default {
  data(){
    return{
      LoadingMSG: true
    }
  }
}
</script>

<style scoped>

</style>